import { render, staticRenderFns } from "./bscdown1.vue?vue&type=template&id=0b8b992e&"
import script from "./bscdown1.vue?vue&type=script&lang=js&"
export * from "./bscdown1.vue?vue&type=script&lang=js&"
import style0 from "./bscdown1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports